export default __webpack_public_path__ + "static/media/linkedin.03e66df9.svg";